<h1 mat-dialog-title>Find Customer</h1>

<div mat-dialog-content class="customer-search-dialog">
    <div class="search-row">
        <div class="search-field">
            <label>{{ searchMode === 'mobile' ? 'Mobile Search' : 'Name Search' }}</label>
            <mat-form-field class="search" appearance="outline">
                <input
                    matInput
                    [attr.aria-label]="searchMode === 'mobile' ? 'Mobile search' : 'Name search'"
                    [placeholder]="searchMode === 'mobile' ? 'type mobile number' : 'type customer name'"
                    [ngModel]="searchText"
                    (ngModelChange)="queueCustomerSearch($event)"
                    cdkFocusInitial>
            </mat-form-field>
        </div>

        <mat-button-toggle-group
            class="search-mode"
            [ngModel]="searchMode"
            (ngModelChange)="changeSearchMode($event)"
            aria-label="Customer search mode">
            <mat-button-toggle value="name">Name</mat-button-toggle>
            <mat-button-toggle value="mobile">Mobile</mat-button-toggle>
        </mat-button-toggle-group>
    </div>

    <mat-progress-bar mode="indeterminate" *ngIf="isSearching"></mat-progress-bar>

    <div class="results" *ngIf="customers.length > 0">
        <div *ngFor="let customer of customers; trackBy: trackByCustomer">
            <button type="button" mat-button (click)="pickCustomer(customer)" class="name">{{ customer.name }}</button>
            <span class="meta" *ngIf="customer.phone" [apPhone]="customer.phone">{{ customer.phone | phone }}</span>
            <span class="meta" *ngIf="customer.email">{{ customer.email }}</span>
        </div>
    </div>

    <div class="empty" *ngIf="searchText && !isSearching && customers.length === 0">
        No matching customers.
    </div>
</div>

<div mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>Cancel</button>
    <button type="button" mat-stroked-button color="primary" (click)="createCustomer(searchText)">
        {{ searchText ? 'Create ' + searchText : 'Create Customer' }}
    </button>
</div>
